// src/routes.js
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Packages from './pages/Packages';
import Couriers from './pages/Couriers';
import Shipments from './pages/Shipments';
import Collections from './pages/Collections';
import Accounts from './pages/Accounts';
import UnknownPackages from './pages/UnknownPackages';
import Claims from './pages/Claims';
import AddUsers from './pages/AddUser';
import Reports from './pages/Reports';
import Login from './pages/Login';
import PrivateRoute from './components/PrivateRoute';
import Staff from './pages/Staff';
import Settings from './pages/Settings';
import CourierLogin from './pages/CourierLogin';
import ForgotPassword from './pages/ForgotPassword';
import ResetPasswordConfirm from './pages/ResetPasswordConfirm';
import FileViewer from './pages/FileViewer';
import BillingsPage from './pages/BillingsPage';
import ManifestPage from './pages/ManifestPage';


const AppRoutes = () => (
  <Routes>
    {/* Public Route */}
    {/* <Route path="/login" element={<Login />} /> */}
    <Route path="/" element={<Login />} />
    <Route path="/courier" element={<CourierLogin />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/confirm-password" element={<ResetPasswordConfirm />} />
    {/* <Route path="/" element={<Landing />} /> */}

    {/* Private Routes */}
    <Route path="/dashboard" element={<PrivateRoute element={Dashboard} />} />
    <Route path="/packages" element={<PrivateRoute element={Packages} />} />
    <Route path="/couriers" element={<PrivateRoute element={Couriers} />} />
    <Route path="/shipments" element={<PrivateRoute element={Shipments} />} />
    <Route path="/collections" element={<PrivateRoute element={Collections} />} />
    <Route path="/billing" element={<PrivateRoute element={BillingsPage} />} />
    <Route path="/accounts" element={<PrivateRoute element={Accounts} />} />
    <Route path="/user" element={<PrivateRoute element={AddUsers} />} />
    <Route path="/staff" element={<PrivateRoute element={Staff} />} />
    <Route path='/file-viewer' element={<PrivateRoute element={FileViewer}/>}/>
    <Route path="/unknown-packages" element={<PrivateRoute element={UnknownPackages} />} />
    <Route path="/claims" element={<PrivateRoute element={Claims} />} />
    <Route path="/reports" element={<PrivateRoute element={ManifestPage} />} />
    <Route path="/settings" element={<PrivateRoute element={Settings} />} />

  </Routes>
);

export default AppRoutes;
